/* eslint-disable @typescript-eslint/no-empty-function */

/**
 * NOTE: Live activities widget is iOS only.
 */
export const useLiveActivityTelemetry = () => {};
